import React from "react";
import auth_logo from "../../assets/auth_logo.png";
import { useNavigate } from "react-router";
import PhoneInput from "react-phone-input-2";
import { webLogoWhite } from "../../assets";

const Add_info = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="auth add_info">
        <div className="custom_container">
          <div className="row">
          
            <div className="col-md-12">
              <div className="login_logo">
                <img src={auth_logo} />

                {/* <img src={webLogoWhite} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Add_info;
